import { apiAxios } from "../../apiConfig";

export const getDonations = async (status = "all") => {
  try {
    const response = await apiAxios.get(`/donations?status=${status}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching donations:", error);
    throw error;
  }
};
